const steps = [
  {
    selector: '[projectlisting-tour="filter"]',
    content: "Click here to collapse/expand filters",
  },
  {
    selector: '[projectlisting-tour="basic-filter"]',
    content: "These are the basic filters"
  },
  {
    selector: '[projectlisting-tour="advance-filter"]',
    content: "Use additional filters to refine the projects"
  },
  {
    selector: '[projectlisting-tour="tabs"]',
    content: "Projects are split into tabs based on their statuses"
  },
  {
    selector: '[projectlisting-tour="datatable-title"]',
    content: "This is the list of projects. You can click on the project's name to navigate to it"
  },
  {
    selector: '[projectlisting-tour="datatable-row"]',
    content: "Click anywhere in the row to see project overview without leaving this page!"
  },
      
];

export default steps;




